module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "LINESPACE",
    attrs: {
      "id": "fmtext"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "LINESPACE"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-TEXT"
  }, [_vm._v("On August 18, 1813, almost four years after the death of Meriwether Lewis, Thomas Jefferson wrote of the explorer, “Of courage undaunted, possessing a firmness & perseverance of purpose which nothing but impossibilities could divert from its direction, careful as a father to those committed to his charge…”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4889e96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fmtext.vue
// module id = 69
// module chunks = 0